import { jsx as t } from "react/jsx-runtime";
import { forwardRef as u, useState as c } from "react";
import { Flex as l } from "../flex/flex.js";
import { ChartPercentage as p } from "./components/chart-percentage.js";
import { ChartLine as f, ChartLinePoint as C } from "./components/chart-line.js";
import { ChartLegend as g, ChartLegends as b } from "./components/chart-legends.js";
import { ChartDoughnut as d, ChartDoughnutSlice as L } from "./components/chart-doughnut.js";
import { ChartContext as x } from "./components/chart-utils.js";
import { ChartBubbles as B, ChartBubble as P } from "./components/chart-bubbles.js";
import { ChartBar as A } from "./components/chart-bar.js";
import { ChartAxis as D, ChartAxisGroup as j } from "./components/chart-axis.js";
import S from "./chart.module.css.js";
import v from "clsx";
const w = u(function({ children: o, className: e, tooltip: r = !0, ...i }, a) {
  const [s, n] = c(), m = r && Object.assign({ color: "white" }, r), h = v(S.chart, e);
  return /* @__PURE__ */ t(x.Provider, { value: { tooltip: m, legends: s, setLegends: n }, children: /* @__PURE__ */ t(l, { as: "figure", className: h, layout: "1", ref: a, ...i, children: o }) });
}), M = Object.assign(w, {
  Axis: D,
  AxisGroup: j,
  Bar: A,
  Bubbles: B,
  Bubble: P,
  Doughnut: d,
  DoughnutSlice: L,
  Legend: g,
  Legends: b,
  Line: f,
  LinePoint: C,
  Percentage: p
});
export {
  M as Chart
};
//# sourceMappingURL=chart.js.map
